import React from 'react';

const e = React.createElement;


function Reset() {}
Reset.prototype = Object.create(React.Component.prototype);


Reset.prototype.render = function() {
  var tr_newpass = "Nieuw wachtwoord";
  var tr_submit = "opslaan";

  if(this.props.language === "EN") {
    tr_newpass = "New password";
    tr_submit = "submit";
  }

  return e('div', null, e('form', {key:"1", onSubmit:this.props.handleReset}, [
    e('div', {key:"11"}, e('input', {type:"password", value:this.props.reset_password, onChange:this.props.handleChange.bind(this, "reset_password"), placeholder:tr_newpass, autoFocus:true})),
    e('div', {key:"12"}, e('input', {type:"submit", value:tr_submit, disabled:this.props.reset_is_fetching})),
  ]));
}


export default Reset



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalAccount_Reset.js
// module id = 251
// module chunks = 0